var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    width: 50,
    height: 50,
    transform: "translate(0)",
    fill: "rgba(0,0,0,0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High_Temp_Icon",
    "data-name": "High Temp Icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M35.2,36.5l-.07-25.747a2.9,2.9,0,0,0-.548-1.809,1.813,1.813,0,0,0-1.5-.646c-1.506,0-2,1.577-2.051,2.435l.069,25.739a5.232,5.232,0,1,0,4.1.028M33.078,9a1.275,1.275,0,0,1,1.058.426,2.16,2.16,0,0,1,.384,1.312l.026,8.615H31.658l-.027-8.591c0-.072.131-1.763,1.447-1.763",
    transform: "translate(-8.114 -2.415)",
    fill: "#e20a15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M32.615,47.3A6.445,6.445,0,0,1,29.4,35.264V10.223a4.369,4.369,0,0,1,.523-2.148,3.01,3.01,0,0,1,2.73-1.607,2.972,2.972,0,0,1,2.726,1.816,4.486,4.486,0,0,1,.452,2.012V35.264A6.445,6.445,0,0,1,32.615,47.3m.055-40.184h-.014a2.368,2.368,0,0,0-2.174,1.28,3.725,3.725,0,0,0-.439,1.831V35.646l-.169.091a5.8,5.8,0,1,0,5.483,0l-.169-.091V10.3A3.847,3.847,0,0,0,34.8,8.575a2.321,2.321,0,0,0-2.135-1.463",
    transform: "translate(-7.615 -1.882)",
    fill: "#e20a15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M25,50A25,25,0,1,1,50,25,25.028,25.028,0,0,1,25,50M25,1.575A23.425,23.425,0,1,0,48.425,25,23.452,23.452,0,0,0,25,1.575",
    transform: "translate(0 0)",
    fill: "#164295"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighTempIcon);
export default __webpack_public_path__ + "static/media/High_Temp_Icon.8ebdcb923a4fdc3a301137cda7a69b15.svg";
export { ForwardRef as ReactComponent };